var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('h4',[_vm._v("403 | Acesso não permitido")]),_c('rkm-link',{attrs:{"to":"/dashboard"}},[_vm._v("Voltar para a página inicial")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }